import { render, staticRenderFns } from "./saveOrganization.vue?vue&type=template&id=5a0386c0&"
import script from "./saveOrganization.vue?vue&type=script&lang=js&"
export * from "./saveOrganization.vue?vue&type=script&lang=js&"
import style0 from "./saveOrganization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports